<template>
  <DataTable
    :value="dataSource"
    data-key="Id"
    v-model:filters="filters"
    filter-display="row"
    show-gridlines
    selection-mode="single"
    edit-mode="row"
    v-model:editing-rows="editingRows"
    state-storage="local"
    scrollable
    scroll-height="80vh"
    paginator
    :loading="false"
    :rows="20"
    :rows-per-page-options="[7, 10, 20, 50]"
    removable-sort
    class="p-datatable-sm"
    v-model:selection="selectedRow"
    @row-edit-save="$emit('row-edit', $event)"
    @row-dblclick="changeNews"
    @row-select="$emit('row-selected', $event)"
  >
    <Column
      :sortable="true"
      field="Vendor"
      header="Артикул"
      bodyStyle="text-align:center"
      :showFilterMenu="false"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      field="Header"
      header="Заголовок"
      style="max-width: 18rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      field="PublicationDate"
      header="Дата публикации"
      bodyStyle="text-align:center"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
      <template #body="slotProps">
        {{  formaterDate(slotProps.data.PublicationDate) }}
      </template>
    </Column>
    <Column
      :sortable="true"
      field="DefferedDate"
      header="Дата отложенной публикации"
      bodyStyle="text-align:center"
      style="max-width: 8rem"
    >
      <template #filter="{filterModel, filterCallback}">
        <InputText
          type="text"
          v-model="filterModel.value"
          class="p-column-filter"
          placeholder="Поиск"
          @input="filterCallback()"
        />
      </template>
      <template #body="slotProps">
        {{  formaterDateTime(slotProps.data.DefferedDate) }}
      </template>
    </Column>
    <Column
      :sortable="true"
      header="Готово к публикации"
      :body-style="{'text-align': 'center'}"
      field="ReadyToPublish"
      :show-filter-menu="false"
      dataType="boolean"
      style="
        min-width: 4rem;
        max-width: 8rem;
      "
    >
      <template #body="slotProps">
        <Checkbox
          v-model="slotProps.data.ReadyToPublish"
          :binary="true"
          disabled
        />
      </template>
      <template #editor="{ data, field }">
        <Checkbox
          v-model="data[field]"
          :binary="true"
        />
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :sortable="true"
      field="Published"
      header="Опубликовано"
      :body-style="{'text-align': 'center'}"
      :show-filter-menu="false"
      style="max-width: 8rem"
    >
      <template #body="slotProps">
        <InputSwitch
          v-model="slotProps.data.Published"
          disabled
        />
      </template>
      <template #editor="{ data, field }">
        <InputSwitch
          v-model="data[field]"
        />
      </template>
      <template #filter="{ filterModel, filterCallback }">
        <TriStateCheckbox
          v-model="filterModel.value"
          @change="filterCallback()"
        />
      </template>
    </Column>
    <Column
      :row-editor="true"
      style="max-width: 10rem;
      min-width: 6rem"
      body-style="text-align:center"
    />
  </DataTable>
</template>

<script>
import { ref, toRef } from 'vue'
// import { useStore } from 'vuex'

import { formaterDate, formaterDateTime } from '@/helpers/helpFunctions.js'
import { policiesValid } from '@/helpers/policiesValidator'

import DataTable from 'primevue/datatable'
import Column from 'primevue/column'
import InputText from 'primevue/inputtext'
import TriStateCheckbox from 'primevue/tristatecheckbox'
import InputSwitch from 'primevue/inputswitch'
import Checkbox from 'primevue/checkbox'

import { FilterMatchMode } from 'primevue/api'

export default {
  name: 'ListTableEducation',
  components: {
    DataTable,
    Column,
    InputText,
    TriStateCheckbox,
    InputSwitch,
    Checkbox
  },
  props: {
    data: {
      type: Array,
      default: () => []
    },
    policies: {
      type: Array,
      default: () => []
    }
  },
  setup (props, { emit }) {
    // const store = useStore()

    // const policies = computed(() => store.getters.getPolicies)

    // нужно для работы таблицы по документации
    const filters = ref({
      Vendor: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      Header: { value: null, matchMode: FilterMatchMode.CONTAINS },
      PublicationDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      DefferedDate: { value: null, matchMode: FilterMatchMode.STARTS_WITH },
      UniversalTagId: { value: null, matchMode: FilterMatchMode.EQUALS },
      ReadyToPublish: { value: null, matchMode: FilterMatchMode.EQUALS },
      Published: { value: null, matchMode: FilterMatchMode.EQUALS }
    })

    const editingRows = ref([])

    const selectedRow = ref()
    // нужно для работы таблицы по документации

    const dataSource = toRef(props, 'data')

    const changeNews = (e) => {
      // if (!policiesValid(props.policies, e.data.UniversalTagId, 'editing')) {
      //   store.dispatch('setShowErrorModal', { Message: 'У Вас нет прав на редактирование' })

      //   return
      // }
      // в том случае если пользователь может редактировать товар/новость
      // то эмитится событие ниже, которе слушается из родительского компонента
      emit('redirectToEditor', e.data.Id)
    }

    return {
      filters,
      policiesValid,
      editingRows,
      dataSource,
      formaterDate,
      changeNews,
      selectedRow,
      formaterDateTime
    }
  }
}
</script>

<style lang="scss" scoped>
:deep(.p-datatable-wrapper) {

  &::-webkit-scrollbar {
    height: 10px; /* толщина горизонтального скролла */
    width: 10px; /* толщина вертикального скролла */
    background-color: rgba(192, 192, 192, 0.5);
  }
  &::-webkit-scrollbar-thumb {
    background-color: rgb(27, 166, 218, 0.7);

    &:hover {
      background-color: rgb(27, 166, 218);
    }
  }
}
:deep(.p-column-filter-row .p-column-filter-menu-button) {
  display: none;
}
:deep(.p-column-filter-row .p-column-filter-clear-button) {
  display: none;
}
</style>
